<template>
	<footer class="eia-stage-footer">
		<slot name="button">
			<eia-button
				class="button-back"
				v-if="clickBack"
				variation="primary"
				size="large"
				@click="clickBack"
				:disabled="false">
				<slot name="button-text">Back</slot>
			</eia-button>
			<eia-button
				class="button-continue"
				variation="primary"
				size="large"
				@click="click"
				:disabled="disabled">
				<slot name="button-text">{{ nextButtonLabel }}</slot>
			</eia-button>
		</slot>

		<eia-caption v-if="caption">
			<slot name="caption">{{ caption }}</slot>
		</eia-caption>

		<eia-button
			class="button-reset"
			v-if="clickReset"
			variation="primary"
			size="large"
			@click="clickReset"
			:disabled="false">
			<slot name="button-text">Restart</slot>
		</eia-button>

	</footer>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
	name: 'eia-stage-footer',

	computed: {
		...mapState( 'stages', [ 'modifiedStageIndex' ] ),
		...mapGetters( 'stages', [ 'totalStages' ] ),

		caption(){
			return this.currentStage.caption || `You will have a chance to check and edit all your details before submitting your proposal`;
		},

		nextButtonLabel(){

			if( this.modifiedStageIndex !== null ){
				return 'Update';
			}

			return this.currentStage.nextButtonLabel || `Continue to Step ${ this.nextStageIndex + 1 }`;
		},

	},

	props: {

		click: {
			type: Function,
			required: true,
		},

		clickBack: {
			type: Function,
			required: false,
		},

		clickReset: {
			type: Function,
			required: false,
		},

		nextStageIndex: {
			type: Number,
			required: true,
		},

		disabled: {
			type: Boolean,
			required: true,
		},

		currentStage: {
			type: Object,
			required: true,
		},

	},
};
</script>

<style lang="scss" scoped>
.eia-stage-footer {
	width: auto;

	.button-back{
		margin-right: 1rem;
	}

	.button-continue{
	}

	.button-reset{
		padding: 0.5rem;
		min-width: 150px;
		margin-top: 1rem;
	}

	.eia-caption {
		display: block;
		_max-width: 300px;
		margin-top: 1rem;
	}
}
</style>
